import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'skipLinePipe'
})
export class SkipLinePipePipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.replace(/\\n/g, '\n') : '';
  }

}
